define(function (require) {
    "use strict";

    var LE = require("app");

    var template = require("personalization-web-agent-templates/widget-templates/widget-list/actionsListItemView.tmpl");

    var KEYS = {
        NAME: "actionName",
        TOOLTIP: "tooltip",
        TOGGLE_AVAILABLE: "toggleAvailable",
        TOGGLE_STATE: "toggleState"
    };

    var ActionsListItemView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        ActionsListItemView = Marionette.ItemView.extend({
            tagName:"tr",
            className: "actions-row",
            template:template,
            ui : {
                checkmarkContainer: ".checkmark-container",
                checkmark: ".checkmark"
            },
            events : {
                "click .actions-row-container" : "_onActionClick"
            },

            /************************** Marionette overriden functions *****************************************/
            initialize : function (options) {
                LEPersonalization.logger.info("Initializing ActionsListItemView", "ActionsListItemView:initialize");
                this._bindEvents();
            },

            onRender:function(){
                LEPersonalization.logger.debug("Rendering ActionsListItemView", "ActionsListItemView:onRender");
                this.$el.attr("title", this.model.get(KEYS.TOOLTIP));
                this._addToggle();
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing ActionsListItemView", "ActionsListItemView:onClose");
            },

            /************************** private functions *****************************************************/
            _bindEvents: function(){
                this.listenTo(this.model, "change:" + KEYS.TOGGLE_STATE, this._toggleCheckmark);
            },

            _toggleCheckmark: function() {
                if(this.model.get(KEYS.TOGGLE_STATE)){
                    this.ui.checkmark.show();
                }
                else{
                    this.ui.checkmark.hide();
                }
            },

            _addToggle:function(){
                if(this.model.get(KEYS.TOGGLE_AVAILABLE)){
                    this.ui.checkmarkContainer.addClass("toggleAvailable");
                    this._toggleCheckmark();
                }
            },

            _onActionClick:function(){
                var currentCheckmarkState = this.$el.find(".checkmark").is(":visible");
                this.trigger("itemview:widget-action-clicked", {actionId: this.model.id, state: !currentCheckmarkState});
            }
        });
    });
    return ActionsListItemView;
});

